import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../app-context';
import IGridComponent from '../../components/grid/i-grid.component';
import IDialogComponent from '../../components/dialog/i-dialog.component';
import TitlePanel from '../../components/title-panel/title-panel.component';
import { EMPTY_STRING, PAGE_SIZE } from '../common/constants';
import { formatDate, isEmptyArray } from '../common/util.services';
import './currency-list.component.scss';
import { deleteCurrency, getCurrency } from './currency.services';
import HistoryComponent from './history/history.component';

const CurrencyList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [role, setRole] = useState<String>('USER');
  const [currencyData, setCurrencyData] = useState(rows);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const columns: GridColDef[] = [
    { field: 'currency', headerName: 'Currency', filterable: false, sortable: false, editable: false, width: 280 },
    { field: 'rate', headerName: 'Rate', filterable: false, sortable: false, editable: false, width: 300 },
    { field: 'contingency', headerName: 'Contingency (%)', filterable: false, sortable: false, editable: false, width: 300 },
    { field: 'date', headerName: 'Date', filterable: false, sortable: false, editable: false, 
      valueFormatter: (date: any) => formatDate(date), width: 300
    },
    {field: 'history', headerName: 'History', filterable: false, sortable: false, width: 100,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openHistoryPopup(params) }}>History</div>}
    },
  ];
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (appContext.userData) {
      setRole(appContext.userData.role);
    }
    if (isEmptyArray(currencyData)) {
      getCurrency(page, pageSize, appContext,
        (response: any) => {
          setCurrencyData(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
        });
    }
  }, [page, pageSize]);

  const handleEditAction = (row: any) => {
    navigate(EMPTY_STRING + row.currency);
  };

  const handleDeleteAction = (row: any) => {
    deleteCurrency(row.currency, appContext,
      (response: any) => {
        setCurrencyData(currencyData.filter((r) => r.currency !== row.currency));
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  };

  const addCurrency = () => {
    navigate('new');
  }

  const handleClose = () => {
    setOpen(false);
  }

  const openHistoryPopup = (params: any) => {
    setRowData(params.row);
    setOpen(true);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getMainPanel = () => {
    return <>
      <IGridComponent title={''} rows={currencyData} columns={columns}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={'ADMIN' === role || 'LFHADMIN' === role} handleDeleteAction={handleDeleteAction} handleEditAction={handleEditAction}
        showApproveAction={false} showAddBtn={'ADMIN' === role || 'LFHADMIN' === role}
        getRowId={(row: any) => row.currency} addRow={addCurrency} />
    </>
  }

  return <>
    <TitlePanel title='Currencies' panelBody={getMainPanel()} />
    <IDialogComponent onClose={handleClose} open={open} title='Currency History' dialogClass={'history-dialog'} 
     dialogBody={<HistoryComponent data={rowData} />} />
  </>
}

export default CurrencyList;